import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	restrictedGroupByWithRollupToTeam: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.group-by.restricted-group-by-with-rollup-to-team',
		defaultMessage: 'Grouping is not supported when rolled up to the team level',
		description:
			'Tooltip to show that the group by is not available when roll-up to team is active',
	},
});
